import React from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  FormElement,
  InputText,
  makeInputWithEmojiPicker,
  INPUT_TEXT_VARIANT_DANGER
} from 'mailup-web-components'
import { pendoTrack } from 'Helpers/pendoTracking'
import { pageState, subjectValidState } from '../recoil/state/page'

const InputWithEmojiPicker = makeInputWithEmojiPicker(InputText)

const InputSubject = () => {
  const intl = useIntl()
  const { id } = useParams()

  const [{ subject, isSubjectDirty, warning }, setSubjectState] = useRecoilState(
    pageState
  )

  const valid = useRecoilValue(subjectValidState)

  const handleChange = ({ target: { value } }) => {
    setSubjectState(prev => ({
      ...prev,
      subject: value,
      isSubjectDirty: true,
      isDirty: true
    }))
  }

  // pendotracking
  const onSelectEmoticon = e => {
    pendoTrack('Messages - Modal Emoji - Impression', {
      idMessage: { id },
      source: 'emailMessageOverview'
    })
  }

  return (
    <FormElement
      required
      label={intl.formatMessage({ id: 'Load.SavedEmailWizard.LabelSubject' })}
      feedback={
        !valid && isSubjectDirty
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
    >
      <InputWithEmojiPicker
        value={subject}
        disabled={warning}
        data-mu-test='input-subject-emoji'
        variant={!valid && isSubjectDirty ? INPUT_TEXT_VARIANT_DANGER : undefined}
        maxLength='200'
        onChange={handleChange}
        onSelectEmoticon={onSelectEmoticon}
        strings={{
          search: intl.formatMessage({
            id: 'Load.EmojiComponent.SearchPlaceholder'
          }),
          clear: intl.formatMessage({ id: 'Load.EmojiComponent.Cancel' }), // Accessible label on "clear" button
          notfound: intl.formatMessage({ id: 'Load.EmojiComponent.NoResult' }),
          categories: {
            search: intl.formatMessage({
              id: 'Load.EmojiComponent.SearchResult'
            }),
            recent: intl.formatMessage({
              id: 'Load.EmojiComponent.CatFrequentlyUsed'
            }),
            smileys: intl.formatMessage({
              id: 'Load.EmojiComponent.CatSmileys'
            }),
            people: intl.formatMessage({ id: 'Load.EmojiComponent.CatPeople' }),
            nature: intl.formatMessage({
              id: 'Load.EmojiComponent.CatAnimals'
            }),
            foods: intl.formatMessage({ id: 'Load.EmojiComponent.CatFood' }),
            activity: intl.formatMessage({
              id: 'Load.EmojiComponent.CatActivity'
            }),
            places: intl.formatMessage({ id: 'Load.EmojiComponent.CatTravel' }),
            objects: intl.formatMessage({
              id: 'Load.EmojiComponent.CatObjects'
            }),
            symbols: intl.formatMessage({
              id: 'Load.EmojiComponent.CatSymbols'
            }),
            // flags: {intl.formatMessage({ id: 'Load.EmojiComponent.CatFlags' })},
            custom: intl.formatMessage({
              id: 'Load.EmojiComponent.CatFrequentlyUsed'
            })
          },
          categorieslabel: intl.formatMessage({
            id: 'Load.EmojiComponent.Categories'
          }) // Accessible title for the list of categories
        }}
      />
    </FormElement>
  )
}

export default InputSubject
